import {makeAutoObservable} from 'mobx';

import {AtLeastOne} from '@/domain/models/Model';
import {defaultSettings, Settings} from '@/domain/models/Settings';
import {hashObject} from '@/shared/lib/hash/hashObject';

class SettingsStore {
  readonly current: Settings = defaultSettings;
  readonly edited: Settings = defaultSettings;

  constructor() {
    makeAutoObservable(this);
  }

  setSettings(settings: Settings) {
    Object.assign(this.current, settings);
    Object.assign(this.edited, settings);
  }

  patchSettings(patch: AtLeastOne<Settings>) {
    Object.assign(this.current, patch);
    Object.assign(this.edited, patch);
  }

  patchEditedSettings(patch: AtLeastOne<Settings>) {
    Object.assign(this.edited, patch);
  }

  resetSettings() {
    this.setSettings(defaultSettings);
  }

  resetEditedSettings() {
    Object.assign(this.edited, this.current);
  }

  getSettingsSearchHash() {
    const filterKeyRelated = [
      'match_gender',
      'match_age_from',
      'match_age_to',
      'discover_near',
      'filter_flags',
    ];
    const filterValues = Object.fromEntries(
      Object.entries(this.current).filter(
        ([key]) => key.startsWith('filter_') || filterKeyRelated.includes(key)
      )
    );
    return hashObject(filterValues);
  }
}

export default new SettingsStore();
